/**
 * House関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'
import LocalDate from '../../domain/type/Date'

const _HotelState = {
  id: null,
  name: '',
  closed_date: '',
  // 画像関連
  terms: null,
  terms_url: '',
  terms_name: '',
  remove_terms_url: null
}

class HotelState extends Record(_HotelState) {
  mergeModel(model) {
    let closed_date = null
    if (model.closed_date) {
      closed_date = new LocalDate(model.closed_date).format('yyyy/MM/dd')
    }

    const terms_name = model.terms_url
    return this.merge({
      id: model.id,
      name: model.name,
      closed_date: closed_date || '',
      terms_name: terms_name ? terms_name.replace(/.*\/|[^.]*\/$/g, '') : '',
      terms_url: model.terms_url
    })
  }
}

export default HotelState
